import {callApi} from '../api'

export const GET_USERS = 'GET_USERS';
export const UPDATE_USER = 'UPDATE_USER';
export const CREATE_USER = 'CREATE_USER';
export const DELETE_USER = 'DELETE_USER';

export function getUsers(cb) {
  return function (dispatch, getState) {
    return callApi(dispatch, getState, 'GET', '/users', null, GET_USERS, cb);
  }
}

export function updateUser(cb, userId, data) {
  return function (dispatch, getState) {
    return callApi(dispatch, getState, 'PATCH', '/users/' + userId, data, UPDATE_USER, cb);
  }
}

export function createUser(cb, data) {
  return function (dispatch, getState) {
    return callApi(dispatch, getState, 'POST', '/users', data, CREATE_USER, cb);
  }
}

export function deleteUser(cb, userId, data) {
  return function (dispatch, getState) {
    return callApi(dispatch, getState, 'DELETE', '/users/' + userId, null, DELETE_USER, cb);
  }
}



// WEBPACK FOOTER //
// ./src/actions/users.js